let checkWLBtn = document.querySelector("form[action='/cart/add']");

const callback = (mutationList) =>{
  for (const mutation of mutationList) {
    if(mutation.target.classList.contains("swym-wishlist-button-bar")){
      let btn = $(mutation.target).detach();
      $(".swym-wishlist-button").html(btn);
      $(".swym-wishlist-button .swym-wishlist-button-bar").show();
    }
  }
}
const checkWLObserver = new MutationObserver(callback);
checkWLObserver.observe(checkWLBtn,{ childList:true, subtree:true })   

function swymCallbackFn(swat){
  if (__st.p == 'product') {
    const target = document.querySelector(".swym-wishlist-modal-container .swym-modals-container");
    let product = window.SwymProductInfo.product;
    const callback = (mutationList) =>{
      for (const mutation of mutationList) {
        if (mutation.target.querySelector(".swym-modal.swym-add-wishlist-modal")) {
          setTimeout(() => {
            if (mutation.target.querySelector(".swym-modal.swym-add-wishlist-modal .swym-product-title .swym-custom-variant-picker") == null) {
              let variants = window.SwymProductInfo.variants;
              let options = '';
              for (let i = 0; i < variants.length; i++) {
                const variant = variants[i];
                options += `<option value="${variant['id']}" data-variant-price="${variant['price']}">${variant['title']}</option>`;
              }
              let variantPicker = `
                <div class="swym-custom-variant-picker">
                  <select class="varinats-picker default" name="custom-variant" id="variants">
                    <option selected>Select Variant</option>
                    ${options}
                  </select>
                </div>`;
              $(".swym-modals-container .swym-add-wishlist-modal .swym-product-title").append(variantPicker);
            }
            // document.querySelector(".swym-add-to-list-btn.swym-button").remove();
            // let btn = `<button class="swym-custom-add-wishlist swym-button product_${product.id}" data-with-epi="true" data-swaction="addToWishlist" data-product-id="${product.id}" data-variant-id="${product.variants[0].id}" data-product-url="${ window.location.origin }/products/${ product.handle }" data-product-img="https:${product.featured_image}" data-price="${product.variants[0].price}" disabled>Add To List</button>`;

            let btn = `<button class="swym-custom-add-wishlist" data-product-id="${product.id}" data-variant-id="${product.variants[0].id}" data-product-url="${ window.location.origin }/products/${ product.handle }" data-product-img="https:${product.featured_image}" data-price="${product.variants[0].price}" disabled>Add To List</button>`;
            $(".swym-add-to-list-btn.swym-button").replaceWith(btn);
            // $(".swym-add-to-list-btn.swym-button").after(btn);  

          }, 1000);
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(target,{ childList:true })    

    $(document).on("change","select[name='custom-variant']",function(){
      let value = $(this).val();
      if (value != '' && value != "Select Variant") {
        $(".swym-custom-add-wishlist").removeAttr("disabled");
        $(".swym-custom-add-wishlist").attr("data-variant-id",value);
        $(".swym-custom-add-wishlist").attr("data-price",$(this).attr('data-variant-price'));
        $(this).removeClass("default");
      }else{
        $(".swym-custom-add-wishlist").attr("disabled",true);
        $(this).addClass("default");
      }
    });

    $(document).on("click",".swym-custom-add-wishlist",async function(){
      let lists = await window.swymCustomCallbacks.getLists(); 
      if (lists.length > 0) {
        // Process for making a list of products
        let attrNames = [];
        var listIds = [];
        $(".swym-wishlist-items button.swym-wishlist-item[aria-checked='true']").each(function() {
          attrNames.push($(this).attr("aria-label"));  
        });
        let listIdsArray = lists.filter(list => attrNames.some(title => title == list['lname'] ));
        listIdsArray.forEach(element => {
          listIds.push(element['lid']);
        });
      }else{
        let listName = $(".swym-new-wishlist-item input.swym-new-wishlist-name").val();
        let getlistId = await window.swymCustomCallbacks.generateNewList(listName);
        var listIds = [getlistId];
      }
      let wlObj = {
        "epi": $(this).attr('data-variant-id'),
        "du": $(this).attr('data-product-url'),
        "empi": $(this).attr("data-product-id"),
        "iu" : $(this).attr("data-product-img"),
        "pr": $(this).attr('data-price')
      };
      _swat.addProductToLists(wlObj, listIds, function(resp){
        let html = `
        <div class="swym-notifications-container swym-notification-wishlist swym-clickable swym-showing swymTopLeft">
          <div class="swym-product-tile"><button class="swym-close-btn swym-is-button"><span
              class="swym-icon"></span></button><img class="swym-image"
              src="${resp[0]['iu']}" alt="">
            <div class="swym-details-container">
              <div class="swym-details" role="alert"><span class="swym-emphasis">${resp[0]['dt']}</span> has been added to <span class="swym-emphasis">1 list</span> successfully.</div>
            </div>
          </div>
        </div>`;
        $(".swym-wishlist-modal-container .swym-modals-container .swym-close-btn").trigger('click');
        $(".swym-wishlist-notifications-container").html(html);
        setTimeout(() => {
          $(".swym-wishlist-notifications-container").html('');
        }, 3000);
        // $(".swym-add-to-wishlist").addClass("swym-added");
      }, function(xhrObject) {
        // something went wrong
        console.log(xhrObject);
      });
    })
  } else if (__st.p == 'collection') {
    const target = document.querySelector(".swym-wishlist-modal-container .swym-modals-container");
    console.log(__st.p)
    let product = SwymProductInfo.product;
    const callback = (mutationList) =>{
      console.log('test1')
      for (const mutation of mutationList) {
        console.log('test2')
        if (mutation.target.querySelector(".swym-modal.swym-add-wishlist-modal")) {
          setTimeout(() => {
            if (mutation.target.querySelector(".swym-modal.swym-add-wishlist-modal .swym-product-title .swym-custom-variant-picker") == null) {
              let variants = SwymProductInfo.variants;
              let options = '';
              for (let i = 0; i < variants.length; i++) {
                const variant = variants[i];
                options += `<option value="${variant['id']}" data-variant-price="${variant['price']}">${variant['title']}</option>`;
              }
              let variantPicker = `
                <div class="swym-custom-variant-picker">
                  <select class="varinats-picker default" name="custom-variant" id="variants">
                    <option selected>Select Variant</option>
                    ${options}
                  </select>
                </div>`;
              $(".swym-modals-container .swym-add-wishlist-modal .swym-product-title").append(variantPicker);
            }

            let btn = `<button class="swym-custom-add-wishlist" data-product-id="${product.id}" data-variant-id="${product.variants[0].id}" data-product-url="${ window.location.origin }/products/${ product.handle }" data-product-img="https:${product.featured_image}" data-price="${product.variants[0].price}" disabled>Add To List</button>`;
            $(".swym-add-to-list-btn.swym-button").replaceWith(btn);
          }, 1000);
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(target,{ childList:true })    

    $(document).on("change","select[name='custom-variant']",function(){
      let value = $(this).val();
      if (value != '' && value != "Select Variant") {
        $(".swym-custom-add-wishlist").removeAttr("disabled");
        $(".swym-custom-add-wishlist").attr("data-variant-id",value);
        $(".swym-custom-add-wishlist").attr("data-price",$(this).attr('data-variant-price'));
        $(this).removeClass("default");
      }else{
        $(".swym-custom-add-wishlist").attr("disabled",true);
        $(this).addClass("default");
      }
    });

    console.log(__st.p)


    $(document).on("click",".swym-custom-add-wishlist",async function(){
      let lists = await window.swymCustomCallbacks.getLists(); 
      if (lists.length > 0) {
        // Process for making a list of products
        let attrNames = [];
        var listIds = [];
        $(".swym-wishlist-items button.swym-wishlist-item[aria-checked='true']").each(function() {
          attrNames.push($(this).attr("aria-label"));  
        });
        let listIdsArray = lists.filter(list => attrNames.some(title => title == list['lname'] ));
        listIdsArray.forEach(element => {
          listIds.push(element['lid']);
        });
      }else{
        let listName = $(".swym-new-wishlist-item input.swym-new-wishlist-name").val();
        let getlistId = await window.swymCustomCallbacks.generateNewList(listName);
        var listIds = [getlistId];
      }
      let wlObj = {
        "epi": $(this).attr('data-variant-id'),
        "du": $(this).attr('data-product-url'),
        "empi": $(this).attr("data-product-id"),
        "iu" : $(this).attr("data-product-img"),
        "pr": $(this).attr('data-price')
      };
      _swat.addProductToLists(wlObj, listIds, function(resp){
        let html = `
        <div class="swym-notifications-container swym-notification-wishlist swym-clickable swym-showing swymTopLeft">
          <div class="swym-product-tile"><button class="swym-close-btn swym-is-button"><span
              class="swym-icon"></span></button><img class="swym-image"
              src="${resp[0]['iu']}" alt="">
            <div class="swym-details-container">
              <div class="swym-details" role="alert"><span class="swym-emphasis">${resp[0]['dt']}</span> has been added to <span class="swym-emphasis">1 list</span> successfully.</div>
            </div>
          </div>
        </div>`;
        $(".swym-wishlist-modal-container .swym-modals-container .swym-close-btn").trigger('click');
        $(".swym-wishlist-notifications-container").html(html);
        setTimeout(() => {
          $(".swym-wishlist-notifications-container").html('');
        }, 3000);
        // $(".swym-add-to-wishlist").addClass("swym-added");
      }, function(xhrObject) {
        // something went wrong
        console.log(xhrObject);
      });
    })
  }
}

if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);

window.swymCustomCallbacks = {
  'changeVariant' : (varinatID) =>{
    $(".swym-button.swym-add-to-wishlist-view-product").attr("data-variant-id",varinatID);
  },
  'getLists' : () =>{
    return new Promise((resolve)=>{
      _swat.fetchLists({
        callbackFn: function(lists) {
          resolve(lists);
        },
        errorFn: function(xhrObj) {
          console.log(xhrObj);
        }
      });
    }) 
  },

  'generateNewList' : (listName) =>{
    return new Promise((resolve)=>{
      _swat.createList({"lname": listName}, function(newListObj){
        // successfully created list
        resolve(newListObj.lid);
      }, function(xhrObject) {
        // something went wrong
        console.log(xhrObject);
      });
    });
  },
}